// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"00720f41","513":"128d4917","703":"e708ee4b","787":"61b62c3a"}[chunkId] + ".chunk.js";
};